// extracted by mini-css-extract-plugin
export default {"card":"session-list-page_card__8ZSUc","list-container":"session-list-page_list-container__Tc2uk","empty-message":"session-list-page_empty-message__kFKDH"};